import {isEmpty, unFormatAmount} from "@/util/Helpers"
import {dateToEpoch, formatDateGRDefault} from "@/util/ConvertDateUtil";
import {INVALID_DATE} from "@/util/EnumUtil";
import {helpers} from "vuelidate/lib/validators";
import moment from "moment";

export const emailValidator = helpers.regex('emailValidator',
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
export const datePatternValidator = helpers.regex('datePatternValidator',
    /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)

export const namesValidator = (value) => {
    let match = (isEmpty(value) ? "" : value.toString().match(/(?:^(?:[Α-Ω/\s\-]+)|(?:[A-Z/\s\-]+)$)|(?:^(?:[A-Z/\s\-]+)|(?:[Α-Ω/\s\-]+)$)/g));
    return (isEmpty(value)) || (!isEmpty(match) && match[0] === value.toString());
}

export const yearValidation = (value, model) => {
    return isEmpty(value) || !isEmpty(value) && (new Date(dateToEpoch(value)).getFullYear() < new Date().getFullYear() && new Date(dateToEpoch(value)).getFullYear() > 1900);
}
export const hmAnalhpshsSyzygouValidator = (value, model) => {
    return isEmpty(value) || dateToEpoch(value) <= dateToEpoch('31/12/' + (model.etosDhloshs))
}
export const afmValidator = (value) => {
    if (!isEmpty(value) && !isEmpty(value)) {
        let afm = value.toString()
        if (afm === '000000000')
            return false;
        if (!afm.match(/^\d{9}$/) || afm === '000000000')
            return false;
        let m = 1, sum = 0;
        for (let i = 7; i >= 0; i--) {
            m *= 2;
            sum += afm.charAt(i) * m;
        }
        return sum % 11 % 10 == afm.charAt(8);
    } else {
        return true
    }
}

export const dateValidator = (value) => {
    if (!isEmpty(value) && value !== '') {
        return formatDateGRDefault(value).toString() !== INVALID_DATE;
    }
    return true
}
export const amountValidator = (value) => {
    if (isEmpty(value)) {
        return true
    } else {
        value = unFormatAmount(value);
        return !isEmpty(value)
    }
}
export const noFutureDateValidator = (value) => {
    return isEmpty(value) || dateToEpoch(value) <= moment.now().valueOf()
}
export const duplicateAfmValidator = (value, model) => {
    return isEmpty(value) || value != model.afm
}
export const hmLhxhsSyzSxesisValidator = (value, model) => {
    return isEmpty(value) || dateToEpoch(value) > dateToEpoch(model.hmniaEnarxhsSyzSxesisCalc)
}
export const isArxiki = (value) => {
    return value.isAnalhpsh == 1
}
export const isBebDiastash = (value) => {
    return value.isBebDiastashCalc == 1
}

export const isValidPDF = (file) => {
    // Check if the file is a PDF
    const isValidType = file.type === 'application/pdf';

    // Check if the file size is smaller than 50MB
    const isValidSize = file.size <= 52428800; // 50MB in bytes
    return isValidType && isValidSize;
};

export const hmniaLhxhsSyzSxesisCalcΟikKatastashValidator = (model) => {
    if (!isEmpty(model)) {
        return model.oikKatastashT056?.t056Id === 3 || model.oikKatastashT056?.t056Id === 7
    }
    return true
}
export const syzygosT063Validators = {
    oikKatastashValidator: function (model) {
        if (!isEmpty(model)) {
            return model.oikKatastashT056?.t056Id !== 1
        }
        return true
    }
}
export const spesificYearValidator = (value, model) => {
    return isEmpty(value) || (new Date(dateToEpoch(model.hmniaEnarxhsSyzSxesisCalc)).getFullYear() == model.etosDhloshs - 1) || (!isEmpty(dateToEpoch(model.hmniaLhxhsSyzSxesisCalc)) && new Date(dateToEpoch(model.hmniaLhxhsSyzSxesisCalc)).getFullYear() == model.etosDhloshs - 1)
}